// Client-side safety pass applied to anything a student types before it leaves
// the browser. The Cloud Functions repeat this work server-side; this copy
// keeps unsafe text out of network logs and out of optimistic UI.

export const filterProfanity = (text) => {
  // eslint-disable-next-line no-useless-escape
  const profanityPatterns = [
    /\b(f+[u*@]+c+k+|f+[u*@]+c+k+[e3]r+|f+[u*@]+c+k+[i1]n+g?|f+c+k+)\b/gi,
    /\b(s+h+[i1*]+t+|s+h+[i1*]+t+t+[iy]+|s+h+[i1*]+t+t+[i1]n+g?)\b/gi,
    /\b(b+[i1*]+t+c+h+|b+[i1*]+t+c+h+[e3]+s+|b+[i1*]+t+c+h+[iy]+)\b/gi,
    /\b(a+s+s+|a+s+s+h+[o0]+l+[e3]+|a+s+s+[e3]+s+)\b/gi,
    /\b(d+[a@]+m+n+|d+[a@]+m+n+[e3]+d+|d+[a@]+m+n+[i1]+t+)\b/gi,
    /\b(h+[e3]+l+l+)\b/gi,
    /\b(c+r+[a@]+p+|c+r+[a@]+p+p+[iy]+)\b/gi,
    /\b(p+[i1]+s+s+|p+[i1]+s+s+[e3]+d+|p+[i1]+s+s+[i1]+n+g?)\b/gi,
    /\b(d+[i1]+c+k+|d+[i1]+c+k+s+|d+[i1]+c+k+h+[e3]+[a@]+d+)\b/gi,
    /\b(c+[o0]+c+k+|c+[o0]+c+k+s+)\b/gi,
    /\b(p+[e3]+n+[i1]+s+)\b/gi,
    /\b(v+[a@]+g+[i1]+n+[a@]+)\b/gi,
    /\b(b+[o0]+[o0]+b+s*|t+[i1]+t+s*|t+[i1]+t+t+[i1]+[e3]+s*)\b/gi,
    /\b(w+h+[o0]+r+[e3]+|s+l+[u*]+t+|h+[o0]+[e3]+)\b/gi,
    /\b(b+[a@]+s+t+[a@]+r+d+)\b/gi,
    /\b(c+[u*]+n+t+)\b/gi,
    /\b(n+[i1]+g+g+[e3a@]+r*|n+[i1]+g+g+[a@]+)\b/gi,
    /\b(f+[a@]+g+|f+[a@]+g+g+[o0]+t+)\b/gi,
    /\b(r+[e3]+t+[a@]+r+d+|r+[e3]+t+[a@]+r+d+[e3]+d+)\b/gi,
    /\b(sp+[i1]+c+|sp+[i1]+c+k+)\b/gi,
    /\b(ch+[i1]+n+k+)\b/gi,
    /\b(k+[i1]+k+[e3]+)\b/gi,
    /\b(w+[e3]+t+b+[a@]+c+k+)\b/gi,
    /\b(g+[o0]+[o0]+k+)\b/gi,
    /\b(d+[iy]+k+[e3]+)\b/gi,
    /\b(tr+[a@]+n+n+[iy]+)\b/gi,
    /\b(qu+[e3]+[e3]+r+)\b/gi,
    /\b(cr+[a@]+c+k+[e3]+r+)\b/gi,
    /\b(wh+[i1]+t+[e3]+y+)\b/gi,
    /\b(g+[iy]+p+s*[iy]+)\b/gi,
    /\b(j+[a@]+p+)\b/gi,
    /\bst+f+u+\b/gi,
    /\bw+t+f+\b/gi,
    /\b(k+[iy]+l+l+\s*(y+[o0]+u+r+)?s+[e3]+l+f+)\b/gi,
    /\bk+y+s+\b/gi,
    /\b(s+u+[i1]+c+[i1]+d+[e3]+)\b/gi,
    /\b(d+[i1]+[e3]+)\b/gi,
  ]

  let filtered = text
  for (const pattern of profanityPatterns) {
    filtered = filtered.replace(pattern, '#####')
  }
  return filtered
}

export const redactPersonalInfo = (text) => {
  let redactedText = text

  // Filter profanity and slurs first
  redactedText = filterProfanity(redactedText)

  // Email addresses
  redactedText = redactedText.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi, '#####')

  // Phone numbers (various formats)
  redactedText = redactedText.replace(/(\+?1[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}/g, '#####')
  redactedText = redactedText.replace(/\b\d{3}[-.\s]?\d{3}[-.\s]?\d{4}\b/g, '#####')

  // Social Security Numbers
  redactedText = redactedText.replace(/\b\d{3}[-.\s]?\d{2}[-.\s]?\d{4}\b/g, '#####')

  // Street addresses (basic pattern: number + street name)
  redactedText = redactedText.replace(/\b\d+\s+[A-Za-z]+\s+(Street|St|Avenue|Ave|Road|Rd|Boulevard|Blvd|Drive|Dr|Lane|Ln|Court|Ct|Way|Circle|Cir|Place|Pl)\.?\b/gi, '#####')

  // Zip codes
  redactedText = redactedText.replace(/\b\d{5}(-\d{4})?\b/g, '#####')

  // "My name is X" or "I'm X" or "I am X" patterns (capture the name after)
  redactedText = redactedText.replace(/\b(my name is|i'm|i am|call me|they call me|people call me)\s+([A-Z][a-z]+(\s+[A-Z][a-z]+)?)/gi, '$1 #####')

  // "I'm X years old" or "I am X years old" patterns
  redactedText = redactedText.replace(/\b(i'm|i am|im)\s+(\d{1,2})\s*(years?\s*old|yrs?\s*old|yo)\b/gi, '$1 ##### years old')

  // Age patterns like "age X" or "X years old"
  redactedText = redactedText.replace(/\b(my age is|age:?)\s*\d{1,2}\b/gi, '$1 #####')
  redactedText = redactedText.replace(/\b(\d{1,2})\s*(years?\s*old|yrs?\s*old|yo)\b/gi, '##### years old')

  // Birthday/DOB patterns
  redactedText = redactedText.replace(/\b(birthday|birth date|dob|date of birth|born on|born)\s*(is|:)?\s*\d{1,2}[/\-.]\d{1,2}[/\-.]\d{2,4}\b/gi, '$1 #####')
  redactedText = redactedText.replace(/\b(birthday|birth date|dob|born on|born)\s*(is|:)?\s*(january|february|march|april|may|june|july|august|september|october|november|december)\s+\d{1,2},?\s*\d{2,4}?\b/gi, '$1 #####')

  // School name patterns
  redactedText = redactedText.replace(/\b(i go to|i attend|i'm at|i am at|my school is|i study at|student at)\s+([A-Z][A-Za-z\s]+\s*)?(school|elementary|middle|high|academy|college|university)\b/gi, '$1 #####')

  // Grade level with school context
  redactedText = redactedText.replace(/\b(in|at)\s+(1st|2nd|3rd|4th|5th|6th|7th|8th|9th|10th|11th|12th|first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth|eleventh|twelfth)\s+grade\s+(at|in)\s+([A-Z][A-Za-z\s]+)/gi, '$1 ##### grade $3 #####')

  // "I live in/at" patterns
  redactedText = redactedText.replace(/\b(i live in|i live at|i'm from|i am from|my address is|located at|located in)\s+([A-Z][A-Za-z\s,]+)/gi, '$1 #####')

  // Social media handles
  redactedText = redactedText.replace(/@[A-Za-z0-9_]+/g, '#####')

  // Discord usernames (username#1234)
  redactedText = redactedText.replace(/[A-Za-z0-9_]+#\d{4}/g, '#####')

  // URLs that might contain personal info
  redactedText = redactedText.replace(/https?:\/\/[^\s]+/gi, '#####')

  // "Contact me at" patterns
  redactedText = redactedText.replace(/\b(contact me at|reach me at|text me at|call me at|message me at)\s+\S+/gi, '$1 #####')

  // Parent/family member names
  redactedText = redactedText.replace(/\b(my (mom|dad|mother|father|brother|sister|parent|guardian)'?s?\s+name is)\s+([A-Z][a-z]+)/gi, '$1 #####')

  return redactedText
}
